import React from 'react';
import HandoffShell, { HandoffLink } from './HandoffShell';
import HandoffWaveform from './HandoffWaveform';
import HandoffLoading from './HandoffLoading';

export type AuthActionStatusKind = 'verifying' | 'emailVerified' | 'passwordChanged' | 'invalidLink';

interface AuthActionStatusProps {
    status: AuthActionStatusKind;
}

function SignInInline() {
    return (
        <a href="/" className="font-semibold text-ink-secondary underline">
            sign in
        </a>
    );
}

// The status screens of /auth/action, where Firebase's emailed links land
// (verify email, reset password). Presentational only — AuthActionPage applies
// the link's code and passes the resulting status in.
function AuthActionStatus({ status }: AuthActionStatusProps) {
    const signIn = <HandoffLink href="/">Sign in</HandoffLink>;

    if (status === 'emailVerified') {
        return (
            <HandoffShell
                waveform={<HandoffWaveform mode="success" />}
                label="Your email has been verified"
                detail={<>You can now <SignInInline /> with your new account.</>}
                action={signIn}
            />
        );
    }

    if (status === 'passwordChanged') {
        return (
            <HandoffShell
                waveform={<HandoffWaveform mode="success" />}
                label="Your password has been changed"
                detail={<>You can now <SignInInline /> with your new password.</>}
                action={signIn}
            />
        );
    }

    if (status === 'invalidLink') {
        return (
            <HandoffShell
                label="This link has expired"
                detail="It may have already been used. Sign in to request a new one."
                action={signIn}
            />
        );
    }

    return <HandoffLoading label="Checking your link" detail="One moment." />;
}

export default AuthActionStatus;
